import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const isLoggedIn = () => {
  return store.state.isUserLoggedIn;
};

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../components/landingPage.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("../components/signupPage.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../components/loginPage.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: () => import("../components/forgotPassword.vue"),
  },
  {
    path: "/verify-email",
    name: "verifyEmail",
    component: () => import("../components/verifyEmail.vue"),
  },
  {
    path: "/profile/edit",
    name: "editUser",
    component: () => import("../components/editUser.vue"),
  },
  {
    path: "/how-it-works",
    name: "howitworks",
    component: () => import("../components/howItWorks.vue"),
  },
  {
    path: "/pricing",
    name: "pricing",
    component: () => import("../components/pricingPage.vue"),
  },
  {
    path: "/features",
    name: "features",
    component: () => import("../components/appFeatures.vue"),
  },
  {
    path: "/faq",
    name: "faqs",
    component: () => import("../components/FAQs.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../components/contactPage.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../components/aboutUs.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../components/userDashboard.vue"),
  },
  {
    path: "/signals",
    name: "signals",
    component: () => import("../components/signalFeed/SignalFeed.vue"),
  },
  {
    path: "/validation",
    name: "validationDashboard",
    component: () => import("../components/Validation/ValidationDashboard.vue"),
  },
  {
    path: "/validation/:id",
    name: "campaignDetail",
    component: () => import("../components/Validation/CampaignDetail.vue"),
  },
  {
    path: "/report/basic/:reportId",
    name: "viewBasicReport",
    component: () => import("../components/viewReport/viewBasicReport.vue"),
  },
  {
    path: "/report/advanced/:reportId",
    name: "viewAdvancedReport",
    component: () => import("../components/viewReport/viewAdvancedReport.vue"),
  },

  // Phase 3: Public shared report (no auth required)
  {
    path: "/report/shared/:shareToken",
    name: "publicReport",
    component: () => import("../components/viewReport/PublicReportView.vue"),
  },

  // Phase 3: Report comparison (auth required)
  {
    path: "/reports/compare",
    name: "compareReports",
    component: () => import("../components/ReportCompare.vue"),
  },

  // Phase 4: Settings page (auth required)
  {
    path: "/settings",
    name: "settings",
    component: () => import("../components/SettingsPage.vue"),
  },

  // Legal Routes
  {
    path: "/terms",
    name: "terms",
    component: () => import("../components/Legal/termsAndConditions.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../components/Legal/privacyPolicy.vue"),
  },
  {
    path: "/refund",
    name: "refund",
    component: () => import("../components/Legal/refundPolicy.vue"),
  },



  // Sample Reports Routes
  {
    path: "/sample-reports",
    name: "sampleReports",
    component: () => import("../components/sampleReports.vue"),
  },
  {
    path: "/sample-reports/basic",
    name: "sampleBasicReport",
    component: () =>
      import("../components/sampleReports/sampleBasicReport.vue"),
  },
  {
    path: "/sample-reports/advanced",
    name: "sampleAdvancedReport",
    component: () =>
      import("../components/sampleReports/sampleAdvancedReport.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/",
    "/login",
    "/signup",
    "/forgot-password",
    "/verify-email",
    "/how-it-works",
    "/pricing",
    "/features",
    "/faq",
    "/contact",
    "/about",
    "/terms",
    "/privacy",
    "/refund",
    "/signals",
    "/sample-reports",
    "/sample-reports/basic",
    "/sample-reports/advanced",
  ];

  // restrict access to login/signup pages after user is logged in
  const isAuthPage = to.path === "/login" || to.path === "/signup";
  if (isAuthPage && isLoggedIn()) {
    return next("/dashboard");
  }
  // Allow shared report routes as public (dynamic path matching)
  const isPublicRoute = publicPages.includes(to.path) || to.path.startsWith('/report/shared/');
  const authRequired = !isPublicRoute;
  const loggedIn = isLoggedIn();

  if (authRequired && !loggedIn) {
    return next("/");
  }

  if (to.path == "/" && loggedIn) {
    return next("/dashboard");
  }

  next();
});

export default router;
